<template>
    <el-form ref="formRef" :disabled="saving" :rules="rules" :model="segment" label-position="top">
        <el-form-item prop="trip_segment_id" label="Trecho">
            <ElSelectV2 :clearable="false" filterable :loading="saving" name="trip_segment_id" v-model="segment.trip_segment_id" :options="options"></ElSelectV2>
        </el-form-item>
        <el-form-item prop="price" label="Preço da viagem">
            <el-input-number :step="0.001" :min="0.001" name="price" v-model="segment.price" />
        </el-form-item>

        <el-button plain  :loading="saving" size="large" type="primary" @click.prevent="submit(formRef)">
            Definir Preço
        </el-button>
    </el-form>
</template>

<script lang="ts" setup>
    import Api from "@/services/api"
    import { Segment } from "@/services/types";
    import { ElMessage, FormInstance, FormRules, ElSelectV2 } from "element-plus"
    import { OptionType } from "element-plus/es/components/select-v2/src/select.types";
    import { reactive, ref, defineProps, defineEmits, computed, watchEffect } from "vue"

    const props = defineProps<{
        travel_company_id: number,
        segments: Segment[]
    }>()
    const emit = defineEmits<{close: []}>()

    const options = computed<Array<OptionType>>(() => {
        return props.segments.map((value: Segment) => {
            return {value: value.id, label: `${value.from?.name} - ${value.to?.name}`}
        })
    })

    const segment = reactive<{price: number, trip_segment_id: number}>({
        trip_segment_id: 1,
        price: 0
    })

    const rules = reactive<FormRules<{price: number, trip_segment_id: number}>>({
        price: [{required: true, message: 'Preencha este campo'}],
        trip_segment_id: [{required: true, message: 'Preencha este campo'}],
    })

    const saving = ref<boolean>(false)
    const formRef = ref<FormInstance>()

    const submit = async (formEl: FormInstance | undefined) => {
        if (!formEl) { return }
        await formEl.validate(async (valid) => {
            if (valid) {
                saving.value = true

                const res = await Api.post(`admin/travel-companies/add-segment/${props.travel_company_id}/${segment.trip_segment_id}`, segment)
                console.log(res.data)
                if (res.status == 200) {
                    ElMessage.success({message: 'Carro cadastrado com sucesso'})
                    emit('close')
                } else if (res.status == 422) {
                    if (res.data.errors) {
                        for(let err in res.data.errors) {
                            ElMessage.error({message: res.data.errors[err].join(', ')})
                        }
                    }
                } else {
                    ElMessage.error({message: 'Ocorreu um erro ' + res.data.message})
                }
                saving.value = false
            }
        })
    }

    watchEffect(() => {
        console.log(segment.trip_segment_id)
    })
</script>
